import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/signatures`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  // Vérifier si l'id contient le flag include_edition_url
  let esignId = id;
  let includeParam = 'include=organization';
  if (esignId.includes('include_edition_url')) {
    includeParam += '&include_edition_url=1';
    esignId = esignId.replace('_include_edition_url', '');
  }
  if (esignId.includes('include_fields')) {
    includeParam += '&include_fields=1';
    esignId = esignId.replace('_include_fields', '');
  }
  return axios
    .get(
      `${url}/signatures/${esignId}?${includeParam}`, 
      options
    )
    .then((response) => {
      let signature = jsona.deserialize(response.data);
      delete signature.links;
      return signature;
    });
}


function getSignedDocuments(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return axios
    .get(
      `${url}/signatures/${id}/download-signed-documents`,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function add(signature) {
  const payload = jsona.serialize({
    stuff: signature,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/signatures?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(signature) {
  const payload = jsona.serialize({
    stuff: signature,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/signatures/${signature.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function send(signature) {
  const payload = jsona.serialize({
    stuff: signature,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/signatures/${signature.id}/send`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/signatures/${id}`, options);
}

function deleteSigner(signatureId, signerId) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/signatures/${signatureId}/signers/${signerId}`, options);
}

function reconcile() {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/signatures/reconcile`, {}, options)
    .then((response) => response.data);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  send,
  getSignedDocuments,
  deleteSigner,
  reconcile
};
